var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitepaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07947 15.74H15.9195C16.3185 15.78 16.6195 16.12 16.6195 16.53C16.6195 16.929 16.3185 17.27 15.9195 17.31H8.07947C7.77947 17.35 7.48947 17.2 7.32947 16.95C7.16947 16.69 7.16947 16.36 7.32947 16.11C7.48947 15.85 7.77947 15.71 8.07947 15.74ZM15.9195 11.179C16.3495 11.179 16.6995 11.53 16.6995 11.96C16.6995 12.39 16.3495 12.74 15.9195 12.74H8.07947C7.64847 12.74 7.29947 12.39 7.29947 11.96C7.29947 11.53 7.64847 11.179 8.07947 11.179H15.9195ZM11.0685 6.65002C11.4995 6.65002 11.8495 7.00002 11.8495 7.42902C11.8495 7.87002 11.4995 8.22002 11.0685 8.22002H8.07947C7.64847 8.22002 7.29947 7.87002 7.29947 7.44002C7.29947 7.01002 7.64847 6.66002 8.07947 6.66002V6.65002H11.0685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepaper);
export default __webpack_public_path__ + "static/media/whitepaper.27f4ee1ff5d763d6122f0bf23cfe34f6.svg";
export { ForwardRef as ReactComponent };